import React, {Component} from "react";
import {map} from "lodash";
import BasicDetail from "./BasicDetail";
import SideBar from "./SideBar";
import Loader from "../../../Common/Component/Loader";
import {message} from "antd";
import {errorHandle} from "../../../Common/errorHandle";

import * as yup from "yup";

// mapping frequency
const frequency_data = [
  {key: 'Twice Weekly', value: 'twice_weekly'},
  {key: 'Weekly', value: 'weekly'},
  {key: 'Every Other Week', value: 'bi_monthly'},
  {key: 'Monthly', value: 'monthly'},
  {key: 'One-Time', value: 'once'},
]

// mapping property type
const property_type = [
  {key: 'Town House', value: 'townhouse'},
  {key: 'Detached', comment: '<.5 acres. lot', value: 'single_family_small'},
  {key: 'Detached', comment: '>.5 acres. lot - FO to assess', value: 'single_family_large'},
]

// mapping cleaning area
const area_clean = [
  { key: 'Front Yard', value: 'front yard'},
  { key: 'Back Yard', value: 'back yard'},
  { key: 'Right Side', value: 'right side'},
  { key: 'Left Side', value: 'left side'},
  { key: 'Dog Run', value: 'dog run'},
  { key: 'Fenced Area', value: 'fenced area'},
  { key: 'Other', value: ''},
];

// mapping last clean
const last_cleaned = [
  { key: 'Less than 2 weeks', value: 'less_than_2_weeks'},
  { key: '2 to 6 weeks', value: '1-2_months'},
  { key: 'More than 6 weeks', value: '2_months_or_more'}
]

// mapping dog count
const dog_count = [{key: '1', value: '1'}, {key: '2', value: '2'}, {key: '3', value: '3'}, {key: '4+', value: '4'}]

class ServiceInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      frequency: '',
      areaClean: [],
      add_ons: [],
      propertyType: '',
      lastCleaned: '',
      dogCount: '',
      franchises: [],
      zipcodeCheck: null,
      disposalLocation: '',
      cleaningNotes: '',
      is_btn_active: false,
      is_basic_btn_active: false,
      is_extra_pet: false,
      extra_pet: '',
      errors: {},
      loader: false,
      otherCleaning: '',
      isOtherCleanArea: false,
      basicDetails: {}
    }
    this.basicDetail = null;
    this.sidebar = null;
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    // check zipcode
    if (Object.keys(nextProps?.zipcodeCheck?.data).length > 0 && nextProps?.zipcodeCheck?.data?.results?.length > 0
      && JSON.stringify(nextProps?.zipcodeCheck?.data?.results) !== JSON.stringify(this.state.franchises)) {
      this.setState({zipcodeCheck: true, franchises: nextProps?.zipcodeCheck?.data?.results, loader: false}, () => this.onPriceCalc(true));
    } else if (JSON.stringify(nextProps?.zipcodeCheck?.data?.results) !== JSON.stringify(this.state.franchises)) {
      this.setState({zipcodeCheck: false, franchises: [], loader: false}, () => this.onPriceCalc(true, false));
    }
  }

  // validate basic detail
  validateBasicInfo = (value) => {
    const {is_basic_btn_active} = this.state;
    if (is_basic_btn_active !== value) {
      this.setState({is_basic_btn_active: value})
    }
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on service detail change
  onTextChange = (e, type) => {
    const calcFields = ['frequency', 'areaClean', 'propertyType', 'lastCleaned', 'dogCount', 'add_ons'];
    const value = type === 'bool' ? e.target.checked : e.target.value;
    if (e.target.name === 'dogCount' && e.target.value === '4') {
      this.setState({is_extra_pet: true})
    } else if(e.target.name === 'dogCount') {
      this.setState({is_extra_pet: false, extra_pet: ''})
    }
    this.setState({ [e?.target?.name]: value }, () => this.onPriceCalc(calcFields.includes(e?.target?.name)))
  }

  // on extra pet change
  onExtraPet = (e) => {
    const value = e.target.value;
    // if (parseInt(value) >= 4 || value === '') {
    this.setState({[e?.target?.name]: value}, () => this.onPriceCalc(true))
    // }
  }
  
  // on clean area changed
  onCleanAreaChanged = (e, value) => {
    const {areaClean} = this.state;
    const idx = areaClean.indexOf(value);
    if (idx <= -1) {
      areaClean.push(value);
    } else {
      areaClean.splice(idx, 1);
    }

    if (!value) {
      if (e.target.checked) {
        this.setState(s => ({ ...s, isOtherCleanArea: true }))
      } else {
        this.setState(s => ({ ...s, isOtherCleanArea: false }))
      }
    }
    this.setState({areaClean},  () => this.onPriceCalc(true))
  }

  // on add ons change
  onAddOnsChange = (e, value, item) => {
    const {add_ons} = this.state;

    const idx = add_ons.findIndex(obj => obj.add_on_uuid === item.uuid);

    if (idx > -1) add_ons.splice(idx, 1);

    if (e.target.checked) {
      add_ons.push({...item, add_on_uuid: item?.uuid, is_recurring: value});
    }
    this.setState({add_ons},  () => this.onPriceCalc(true));
  }

  // validate required field
  validate = (action) => {
    const {
      frequency,
      propertyType,
      dogCount,
      is_extra_pet,
      extra_pet,
      areaClean,
      otherCleaning,
      lastCleaned
    } = this.state;

    this.basicDetail.validate().then((res) => {
      if (res === 'success') {
        const schema = yup.object().shape({
          frequency: yup.string().required('Frequency Is Required.'),
          propertyType: yup.string().required('Place Is Required.'),
          is_extra_pet: yup.bool(),
          dogCount: yup.string().test('match', 'Please select the number of dogs.', (dogCount) => {
            if (!is_extra_pet) return dogCount
            return true
          }),
          extra_pet: yup.string().test('match', 'Please enter a value between 4 and 99.', (extra_pet) => {
            if (is_extra_pet) return extra_pet
            return true
          }),
          areaClean: areaClean.length === 0 ? yup.string().required('Please select at least one cleaning area') : null,
          otherCleaning: areaClean.indexOf("") > -1 && (otherCleaning === undefined || otherCleaning === '') ? yup.string().required('Please enter the Other cleaning area.') : null,
          lastCleaned: yup.string().required('Please select when the property was last cleaned.'),
        });

        const data = { frequency, propertyType, dogCount, is_extra_pet, extra_pet, areaClean, lastCleaned };

        schema.validate(data, { abortEarly: false }).then(() => {
          this.setState({is_btn_active: true, errors: {}}, () =>
            // this.props.onTabChange(1),
            this.props.setBasicData(this.state.basicDetails),
          this.storeInLocal()
          )
        }).then(()=>{
          this.props.onTabChange(1)
          this.storeInLocal()
        }).catch((error) => {
          let err_data = {};
          map(error.inner, (item) => { err_data[item.path] = item.message });
          this.setState({errors: err_data});
        });
      }
    }) // end basic detail validate
  };

  // on price calc
  onPriceCalc = (isCalcField = false, isStoreInLocal = true) => {
    if (isStoreInLocal) this.storeInLocal();
    if (isCalcField && this.state.zipcodeCheck) this.props.priceCalc();
  }

  // store data in local storage
  storeInLocal = () => {
    const {
      frequency,
      areaClean,
      propertyType,
      lastCleaned,
      dogCount,
      zipcodeCheck,
      disposalLocation,
      cleaningNotes,
      add_ons,
      extra_pet,
      is_extra_pet,
      franchises,
      otherCleaning
    } = this.state;
    
    /**
     * RMS: Storage values in local state variable
     */
    let area_to_clean = [];

    if (areaClean && areaClean.length > 0) {
      area_to_clean = areaClean;
      const idx = area_to_clean.indexOf("");
      
      if (idx > -1) {
        area_to_clean[idx] = otherCleaning;
      }
    }

    this.props.setServiceInfoData({ 
      frequency: frequency, 
      add_ons: add_ons, 
      areaClean: area_to_clean, 
      propertyType: propertyType, 
      lastCleaned: lastCleaned, 
      dogCount: dogCount,
      zipcodeCheck: zipcodeCheck,
      disposalLocation: disposalLocation,
      cleaningNotes: cleaningNotes,
      extra_pet: extra_pet,
      is_extra_pet: is_extra_pet,
      franchises: franchises,
      otherCleaning: otherCleaning 
    });

    /**
     * RMS: This localStorage is used to display sidebar details calculation
     */
    sessionStorage.setItem('step1', JSON.stringify({
      frequency,
      add_ons,
      areaClean,
      propertyType,
      lastCleaned,
      dogCount,
      zipcodeCheck,
      disposalLocation,
      cleaningNotes,
      extra_pet,
      is_extra_pet,
      franchises,
      otherCleaning
    }));
  }

  onCancel = () => {
    this.props.history.goBack();
    sessionStorage.removeItem('basicDetail');
    sessionStorage.removeItem('step1');
    sessionStorage.removeItem('calcData');
    sessionStorage.removeItem('pricingCalc');
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3513></DP-3513>
   */
  setBasicDetails = (data) => {
    this.setState({ basicDetails: data }, () => {
      // console.warn('basicDetails', data);
    });
  }

  render() {
    const {
      frequency,
      areaClean,
      add_ons,
      propertyType,
      lastCleaned,
      dogCount,
      franchises,
      zipcodeCheck,
      extra_pet,
      is_extra_pet,
      errors,
      loader,
      cleaningNotes,
      disposalLocation,
      otherCleaning,
      isOtherCleanArea
    } = this.state;

    return (
      <div className="container new-cust">
        {loader && <Loader />}
        <div className="fluid-block">
          <div className="article-block">
            <BasicDetail
              ref={(ref) => this.basicDetail = ref}
              
              // reducers
              zipcodeCheck={this.props.zipcodeCheck}
              GoogleApi={this.props.GoogleApi}
              EmailVerifycation={this.props.EmailVerifycation}

              // apis
              checkEmail={this.props.checkEmail}
              checkZipCode={this.props.checkZipCode}
              resetCheckZipcode={this.props.resetCheckZipcode}
              getGeocodeAddress={this.props.getGeocodeAddress}
              resetGeocodeAddress={this.props.resetGeocodeAddress}
              setBasicDetails={this.setBasicDetails}
            />
            <div className={`adetail ${zipcodeCheck ? '' : 'disabled'}`}>
              <h3>Base Cleaning Requirements</h3>
              <div className="form-block">
                <div className="frow">
                  <h4>How often do you need your yard cleaned?</h4>
                  <div className="oplist">
                    {map(frequency_data, (item, index) => {
                      return (
                        <div className="inline-checks" key={`frequency${index}`}>
                          <label htmlFor={item?.value} className={`${frequency === item?.value ? 'active' : ''}`}>
                            <input type="radio" id={item?.value} name="frequency" disabled={!zipcodeCheck} className="" value={item?.value} onChange={() => this.onTextChange({target: {name: 'frequency', value: item?.value}})}/>
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )}
                    )}
                  </div>
                  {errors?.['frequency'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['frequency']}</label> : ''}
                </div>
                <div className="frow md-label">
                  <h4>What’s your place like?</h4>
                  <div className="oplist">
                    {map(property_type, (item, index) => {
                      return (
                        <div className="inline-checks" key={`propertyType${index}`}>
                          <label htmlFor={item?.value} className={`${propertyType === item?.value ? 'active' : ''}`}>
                            <input type="radio" id={item?.value} name='propertyType' disabled={!zipcodeCheck} className="" value={item?.value} onChange={() => this.onTextChange({target: {name: 'propertyType', value: item?.value}})}/>
                            <span>{item?.key} <br/> {item?.comment}</span>
                          </label>
                        </div>
                      )
                    })}
                  </div>
                  {errors?.['propertyType'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['propertyType']}</label> : ''}
                </div>
                <div className="frow md-label">
                  <h4>How many pups on property?</h4>
                  <div className="oplist">
                    {
                      map(dog_count, (item, index) => {
                        return (
                          <div className="inline-checks" key={`dogCount${index}`}>
                            <label htmlFor={`dogCount${index}`} className={`${dogCount === item?.value ? 'active' : ''}`}>
                              <input type="radio" id={`dogCount${index}`} name='dogCount' disabled={!zipcodeCheck} className="" value={item?.value} onChange={() => {
                                this.onTextChange({target: {name: 'dogCount', value: item?.value}})
                                this.onExtraPet({target: {name: 'extra_pet', value: item?.value}})
                              }}/>
                              <span>{item?.key}</span>
                            </label>
                          </div>
                        )
                      })}
                  </div>
                  {is_extra_pet &&
                  <div className="fitem">
                    <input
                      type='text'
                      name='extra_pet'
                      maxLength={2}
                      minLength={1}
                      disabled={!zipcodeCheck}
                      value={extra_pet}
                      onChange={(e) => this.onNumericInputChange(e.target.value) && this.onExtraPet(e) && this.onTextChange({target: {name: 'dogCount', value: e}}) }
                      placeholder="Please specify the exact number of dogs" />
                  </div>
                  }
                  {errors?.['dogCount'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['dogCount']}</label> : ''}
                  {errors?.['extra_pet'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['extra_pet']}</label> : ''}
                </div>
                <div className="frow md-label">
                  <h4>When was your yard last cleaned?</h4>
                  <div className="oplist">
                    {map(last_cleaned, (item, index) => {
                      return (
                        <div className="inline-checks" key={`lastCleaned${index}`}>
                          <label htmlFor={item?.value} className={`${lastCleaned === item?.value ? 'active' : ''}`}>
                            <input type="radio" id={item?.value} name='lastCleaned' disabled={!zipcodeCheck} className="" value={item?.value} onChange={() => this.onTextChange({target: {name: 'lastCleaned', value: item?.value}})}/>
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )
                    })}
                  </div>
                  {errors?.['lastCleaned'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['lastCleaned']}</label> : ''}
                </div>
                <hr/>
                <h3>Customizable the Clean</h3>

                <div className="frow sm-label">
                  <h4 className="flex">Areas to clean <small>1 area included in price, add ${franchises?.[0]?.additional_cleaning_area_price ? franchises?.[0]?.additional_cleaning_area_price : '0'}/visit for each additional area. </small></h4>
                  <div className="oplist">
                    {map(area_clean, (item, index) => {
                      const isIncluded = areaClean?.includes(item?.value)
                      return (
                        <div className="inline-checks" key={`areaClean${index}`}>
                          <label htmlFor={item?.value} className={isIncluded ? "active" : ''}>
                            <input type="checkbox" id={item?.value} name={item?.value} disabled={!zipcodeCheck} className="" value={item?.value} onChange={(e) => this.onCleanAreaChanged(e, item?.value)}/>
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )}
                    )}
                    {isOtherCleanArea && <div className="from-group w-100">
                      <div className="fitem">
                        <input 
                          type="text" 
                          id="bi_monthly1" 
                          name="bi_monthly" 
                          placeholder="Additional other areas to clean"
                          value={otherCleaning}
                          onChange={(e) => {
                            this.setState({otherCleaning: e.target.value });
                          }}
                        />
                      </div>
                    </div>}
                  </div>
                </div>
                {errors?.['areaClean'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['areaClean']}</label> : ''}
                {errors?.['otherCleaning'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['otherCleaning']}</label> : ''}
              </div>
              <div className="form-block">
                <h4 className="flex">Additional Services</h4>
                <div className="frow sm-label flex flex-start flex-wrap">
                  {
                    map(franchises?.[0]?.add_on, (item, index) => {
                      const currentAddOn = add_ons.filter(obj => obj.add_on_uuid === item.uuid)
                      const eachVisit = currentAddOn.length > 0 ? currentAddOn?.[0]?.is_recurring : false;
                      const firstVisit = currentAddOn.length > 0 ? !currentAddOn?.[0]?.is_recurring : false;
                      
                      if (item?.is_active) {
                        return (
                          <div className="oplist flex flex-column selected" key={`addons${index}`}>
                            <h5>{item?.name} <br/> +${item?.cost_per_visit} per visit</h5>
                            <div className="flex">
                              <div className="inline-checks">
                                <label htmlFor={`firstvisit${index}`} className={firstVisit ? "active" : '' }>
                                  <input type="checkbox" id={`firstvisit${index}`} name="is_recurring" disabled={!zipcodeCheck} className="" value={!item?.is_recurring}
                                    onChange={(e) => this.onAddOnsChange(e, false, item)} />
                                  <span>First Visit</span>
                                </label>
                              </div>
                              <div className="inline-checks">
                                <label htmlFor={`eachvisit${index}`}  className={eachVisit ? "active" : '' }>
                                  <input type="checkbox" id={`eachvisit${index}`} name="is_recurring" disabled={!zipcodeCheck} className="" value={item?.is_recurring}
                                    onChange={(e) => this.onAddOnsChange(e, true, item)}/>
                                  <span>Each Visit</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        )
                      }
                    })
                  }
                </div>
              </div>
              <div className="form-block">
                <div className="frow">
                  <h4>Scooped waste disposal location</h4>
                  <p>Our standard policy is to double bag the scooped waste, tie it securely to contain odor, and place it in your garbage can. Please let us know where the garbage can is located or if you’d like the bagged waste placed elsewhere.</p>
                  <div className="form-group">
                    <div className="fitem">
                      <input type="text" placeholder="Scooped Waste Dispotal Location" disabled={!zipcodeCheck} name="disposalLocation" value={disposalLocation} onChange={(e) => this.onTextChange(e)}/>
                    </div>
                  </div>
                </div>
                <div className="frow">
                  <h4>Cleaning Notes</h4>
                  <p>Any special instructions about your property that we should know? (e.g. gate code, yard aces etc.)</p>
                  <div className="form-group">
                    <div className="fitem">
                      <input type="text" placeholder="Additional cleaning notes" disabled={!zipcodeCheck} name="cleaningNotes" value={cleaningNotes} onChange={(e) => this.onTextChange(e)}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <SideBar
            ref={(ref) => this.sidebar = ref}
            coupon_code={this.state.coupon_code}
            setCouponCode={(value) => this.setState({coupon_code: value})}
            // reducers
            zipcodeCheck={this.props.zipcodeCheck}
            PricingCalc={this.props.PricingCalc}
            //
            priceCalc={this.props.priceCalc}
            // frequency={frequency}
            currentTab={this.props.currentTab}
            serviceInfo={{
              frequency: frequency, 
              add_ons: add_ons, 
              areaClean: areaClean, 
              propertyType: propertyType, 
              lastCleaned: lastCleaned, 
              dogCount: dogCount,
              zipcodeCheck: zipcodeCheck,
              disposalLocation: disposalLocation,
              cleaningNotes: cleaningNotes,
              extra_pet: extra_pet,
              is_extra_pet: is_extra_pet,
              franchises: franchises,
              otherCleaning: otherCleaning 
            }}
          />
        </div>
        <div className="fix-btn-grp" style={{width: "100%"}}>
          <button className="btn btn-white" onClick={() => this.onCancel()}>Cancel</button>
          <button className={`btn btn-warning`} onClick={() => this.validate('save')}>Next: GO TO BILLING</button>
        </div>
      </div>
    )
  }
}

export default ServiceInfo;